import { Text, Column } from '@smuchile/pkg-unimarc-components'
import {
  BigScreen,
  SmallScreen,
  getBemId
} from '@smuchile/pkg-unimarc-components/helpers'
import style from './Name.module.css'

export interface NameProps {
  isNotAvailableProduct?: boolean
  name: string
}

export const Name = ({
  isNotAvailableProduct,
  name
}: NameProps): React.ReactElement<NameProps> => {
  return (
    <>
      <BigScreen>
        <Column customWidth='100'>
          <Text
            customClassName={style.productName__name}
            fontSize='lg'
            id={getBemId('shelfProductName', 'text')}
            lineClamp={2}
            truncate={isNotAvailableProduct ? 50 : 52}
          >
            {name}
          </Text>
        </Column>
      </BigScreen>

      <SmallScreen>
        <Column>
          <Text
            customClassName={style.productName__name}
            fontSize='sm'
            id={getBemId('shelfProductName', 'text')}
            lineClamp={2}
            truncate={isNotAvailableProduct ? 70 : 45}
          >
            {name}
          </Text>
        </Column>
      </SmallScreen>
    </>
  )
}
